// containers/ConfirmAppointmentAwareness.js
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { confirmAppointmentAwareness } from '../../actions/appointments';
import { sendSentryError } from '../../setup/sentry';

const ConfirmAppointmentAwareness = ({ token, confirmAppointmentAwarenessAction, history }) => {
  const { appointmentId } = useParams();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (!appointmentId) {
      setTimeout(() => {
        history.push('/');
      }, 2000);
      return;
    }

    // Since we're using PrivateRoute, user is guaranteed to be logged in here
    handleConfirmAwareness();
  }, []); // Empty dependency array to run only once

  const handleConfirmAwareness = async () => {
    try {
      setIsLoading(true);

      await confirmAppointmentAwarenessAction({
        token,
        appointmentId,
        successCallback: () => {
          console.log('Appointment awareness confirmed successfully');
          // Redirect to bookings with success parameter
          history.push('/bookings?awareness=success');
        },
        errorCallback: (error) => {
          console.error('Error confirming appointment awareness:', error);
          sendSentryError({ error, context: 'confirmAppointmentAwareness' });
          // Redirect to bookings with error parameter
          history.push('/bookings?awareness=error');
        }
      });
    } catch (error) {
      console.error('Error confirming appointment awareness:', error);
      sendSentryError({ error, context: 'confirmAppointmentAwareness' });
      // Redirect to bookings with error parameter
      history.push('/bookings?awareness=error');
    } finally {
      setIsLoading(false);
    }
  };

  if (isLoading) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
          flexDirection: 'column'
        }}>
        <div>Confirming your appointment...</div>
        <div style={{ marginTop: '10px', fontSize: '14px', color: '#666' }}>Please wait while we process your confirmation.</div>
      </div>
    );
  }

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        flexDirection: 'column'
      }}>
      <div>Confirming your appointment awareness...</div>
      <div style={{ marginTop: '10px', fontSize: '14px', color: '#666' }}>Please wait while we process your confirmation.</div>
    </div>
  );
};

ConfirmAppointmentAwareness.propTypes = {
  token: PropTypes.string,
  user: PropTypes.object,
  confirmAppointmentAwarenessAction: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired
};

const mapStateToProps = (state) => ({
  token: state.user?.token,
  user: state.user
});

export default connect(mapStateToProps, {
  confirmAppointmentAwarenessAction: confirmAppointmentAwareness
})(ConfirmAppointmentAwareness);
